import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { FaLock } from "react-icons/fa";

import ConstData from "../../../lib/ConstData";

import CustomProfileImage from "../../user/profile/CustomProfileImage";
import Alerts from "../../etc/list/Alerts";

const WebUserPWResetAlertModal = ({ isModalOpened, selectedMemberInfo, toggleModalOpened, onClickResetUserPW, alertKind, alertMessage }) => {
    const { t } = useTranslation();

    const [memberInfo, setMemberInfo] = useState(selectedMemberInfo);
    const [password, setPassword] = useState("");

    const [lAlertMessage, setAlertMessage] = useState("");
    const [lAlertKind, setAlertKind] = useState(ConstData.ALERT_KIND.NONE);

    useEffect(() => {
        setAlertKind(alertKind);
    }, [alertKind]);

    useEffect(() => {
        setAlertMessage(alertMessage);
    }, [alertMessage]);

    useEffect(() => {
        setMemberInfo(selectedMemberInfo);
    }, [selectedMemberInfo]);

    const onChangePassword = (e) => {
        if (lAlertKind !== ConstData.ALERT_KIND.NONE) {
            setAlertKind(ConstData.ALERT_KIND.NONE);
            setAlertMessage("");
        }

        setPassword(e.target.value);
    }

    const checkInputValue = () => {
        if (password === undefined || password === null || password === "") {
            setAlertMessage(t("유효성_검사_비밀번호_입력오류", { ns: "user" }));
            setAlertKind(ConstData.ALERT_KIND.DANGER);
        } else {
            onClickResetUserPW(memberInfo.subDomainSeq, memberInfo.userSeq, password);
        }
    }

    const onCloseModal = () => {
        setAlertKind(ConstData.ALERT_KIND.NONE);
        setAlertMessage("");
    }

    return (
        // 260805 web-light-modal: 전역 다크 테마 모달 스타일과 분리해 web 화면 톤(라이트)에 맞춤 - index.css의 --modal-* 변수를 라이트 값으로 재정의
        <Modal isOpen={isModalOpened} centered backdrop={true} onClosed={onCloseModal} className="web-light-modal">
            <div className="card container-fluid">
                <div className="card-body">
                    <div className="title-area text-center dark-grey-text">
                        <span>
                            {t("관리자_비밀번호_변경_문구_1", { ns: "admin" })}<br />
                            {t("관리자_비밀번호_변경_문구_2", { ns: "admin" })}
                        </span>
                    </div>
                    <div className="content-area dark-grey-text">
                        <span className="small mb-1">[{t("관리자_비밀번호_변경_문구_3", { ns: "admin" })}]</span>
                        <div className="d-flex align-items-center justify-content-center mb-3 area-80">
                            <div className="area-15 fit-content">
                                <CustomProfileImage url={memberInfo.profileImgUrl} style={{ width: '2rem', height: '2rem' }} alt={memberInfo.userNickname} />
                            </div>
                            {/* 260804 닉네임이 길 때 잘리지 않던 문제 수정 - admin-ellipsis-cell/text로 말줄임(...) 처리 */}
                            <div className="d-flex align-items-center justify-content-center admin-ellipsis-cell" style={{ flex: '1 1 auto' }}>
                                <span className="hiclass-text admin-ellipsis-text" title={memberInfo.userNickname}>
                                    <b>{memberInfo.userNickname}</b>
                                </span>
                            </div>
                        </div>
                        <div className="d-flex input-group justify-content-center px-2">
                            <div className="d-flex align-items-center justify-content-center mr-2">
                                <FaLock className="font-md blue-text" title={t("비밀번호", { ns: "user" })} />
                            </div>
                            <input type="password" id="resetMemberPw" className="web-search-input px-2 area-80" placeholder={t("유효성_검사_비밀번호_입력오류", { ns: "user" })} onChange={onChangePassword} value={password} />
                        </div>
                        <Alerts kind={lAlertKind} message={lAlertMessage} />
                    </div>
                    <div className="d-flex justify-content-center my-2">
                        <button type="button" className="btn red white-text mr-1 py-1 px-2" onClick={checkInputValue}>{t("예", { ns: "common" })}</button>
                        <button type="button" className="btn green white-text ml-1 py-1 px-2" onClick={() => toggleModalOpened(false)}>{t("아니오", { ns: "common" })}</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default WebUserPWResetAlertModal;